<template>
    <div class="h-full w-full flex items-center justify-center">
        <div class="h-full">
            <button
                v-if="mainItem && mainItem.permissions"
                @click="mainItem.click(data)">
                {{ mainItem.label }}
            </button>
            <hts-dropdown
                v-if="options.length > 1"
                class="flex items-center"
                :options="options"
                :placement="'left'"
                label-key="label"
                @click="(action) => dropdownMenuClick(action)">
                <template #reference>
                    <div class="flex items-center text-cyan-600">
                        <span v-if="!mainItem || !mainItem.permissions">
                            Chọn
                        </span>
                        <hi-chevron-down-icon
                            class="h-6 w-6"
                            aria-hidden="true" />
                    </div>
                </template>
            </hts-dropdown>
            <div
                v-else-if="options.length"
                class="flex items-center m-1 p-2 outline-0 !rounded cursor-pointer"
                :class="options[0].class"
                @click="dropdownMenuClick(options[0])">
                <component
                    :is="options[0].icon"
                    v-if="options[0].icon"
                    class="w-4 h-4 mr-1" />
                <span class="p-0 leading-5">
                    {{ options[0].label || '...' }}
                </span>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
const props = defineProps({
  params: Object
})
const store: any = $store()
const { params } = toRefs(props)
const isArchive = computed(() => {
  const storeKey: any = typeof params?.value?.storeKey === 'string' ? params.value.storeKey : ''
  if (storeKey && params?.value?.storeName) {
    return store[storeKey][`getIs${params?.value?.storeName}Archive`]
  }
  return true
})
const items: any = computed(() => params?.value?.items || [])
const mainItem = computed(() => params?.value?.main || null)
const data = computed(() => params?.value?.node?.data || null)
const options = computed(() => {
  const result: any = []
  if (params?.value?.storeKey && params?.value?.storeName) {
    items.value.forEach((item: any) => {
      if (item.permissions === undefined) {
        result.push(item)
      } else if (item.permissions) {
        if (!(typeof item.validate === 'function')) {
          if (isArchive.value) {
            if (item.isArchive || item.isAll) {
              result.push(item)
            }
          } else if (!item.isArchive) {
            result.push(item)
          }
        } else if (item.validate(params?.value?.data)) {
          if (isArchive.value) {
            if (item.isArchive || item.isAll) {
              result.push(item)
            }
          } else {
            result.push(item)
          }
        }
      }
    })
  }
  return result
})

const dropdownMenuClick = (action: any) => {
  action.click(data.value || {})
}
</script>
